import _ from 'lodash'
import moment from 'moment'
import { createSelector } from 'reselect'

import * as Compartment from './compartment.js'

export const getEncountersHistory = redux =>
  _.chain(redux)
    .get('encountersHistory.data', [])
    .map(e => {
      const encounterTypes = {
        home: 'In Home Encounter',
        phone: 'Telephonic Encounter',
        mobile: 'Mobile Encounter',
        email: 'Email Encounter',
        administrative: 'Administrative Update',
        grandRounds: 'Grand Rounds',
        cms: 'Monthly Summary',
        aps: 'APS',
        researchReview: 'Research'
      }

      const encounterType = encounterTypes[e.document.type] || 'Unknown'

      return {
        type: 'encounter',
        datetime: e.document.encounterEndTime,
        title: encounterType,
        patientId: e.subject_id,
        encounterId: e.id,
        careplanReportId: e.document.careplanReportId,
        grandRoundsReportId: e.document.grandRoundsReportId,
        encounterSummaryReportId: e.document.encounterSummaryReportId,
        patientSummaryReportId: e.document.patientSummaryReportId,
        patientBriefReportId: e.document.patientBriefReportId,
        monthlySummaryReportId: e.document.monthlySummaryReportId,
        apsReportId: e.document.apsReportId,
        researchReviewReportId: e.document.researchReviewReportId,
        edited: !_.isEmpty(e.document.history)
      }
    })
    .value()

const encounterTypeTexts = {
  'Telephone encounter (procedure)': 'phone',
  'Mobile encounter (procedure)': 'mobile',
  'Email encounter (procedure)': 'email',
  'Home visit (procedure)': 'home'
}

const getFinishedEncounters = createSelector(
  Compartment.encounters,
  encounters => {
    if (!encounters) {
      return null
    }
    return encounters
      .filter(e => e.status === 'finished')
      .filter(e =>
        Object.keys(encounterTypeTexts).includes(_.get(e, 'type[0].text')))
  }
)

export const getLastEncounter = createSelector(getFinishedEncounters, _.last)
export const getLastEncounterType = createSelector(getLastEncounter, e => _.get(encounterTypeTexts, _.get(e, 'type[0].text')))
export const getLastEncounterTimeAgo = createSelector(getLastEncounter, e => {
  const time = _.get(e, 'meta.lastUpdated')
  if (!time) {
    return null
  }
  return moment(time).subtract('days').fromNow()
})
